import { render, staticRenderFns } from "./commercial.vue?vue&type=template&id=54938606&scoped=true&"
import script from "./commercial.vue?vue&type=script&lang=js&"
export * from "./commercial.vue?vue&type=script&lang=js&"
import style0 from "./commercial.vue?vue&type=style&index=0&id=54938606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54938606",
  null
  
)

export default component.exports